import type { JSX } from 'react';

interface LoaderProps {
  /** Additional CSS classes */
  className?: string;
  /** Show loader centered on full screen */
  fullscreen?: boolean;
}

/**
 * Loading spinner component.
 * Use `fullscreen` prop to center on the entire viewport.
 */
export const Loader = ({ className = '', fullscreen = false }: LoaderProps): JSX.Element => {
  if (fullscreen) {
    return (
      <div className='page-centered'>
        <div className={`spinner ${className}`.trim()} />
      </div>
    );
  }

  return <div className={`spinner ${className}`.trim()} />;
};
